module.exports = "<p class=\"weui_media_desc\"><slot></slot></p>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/media/media-description.vue
 ** module id = 169
 ** module chunks = 0
 **/